import { Box, styled, Typography, Button } from '@mui/material';

export const HeaderDrawer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #bdbdbd;
  padding: 0px 0px 16px;
  position: relative;

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
  }
`;

export const BreadCrumbContainer = styled(Box)`
  display: flex;
  align-items: center;
  padding: 18px 0 10px;
  flex-wrap: wrap;
`;

export const BreadCrumbBox = styled(Box)`
  margin-left: 5px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  margin-right: 8px;

  strong {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000;
    text-transform: capitalize;
  }
`;

export const CardSectionBack = styled(Button)`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 48px;
  color: #424242;
  text-transform: capitalize;

  svg {
    color: #424242;
  }

  :hover {
    background-color: #e9e9e9;
    cursor: pointer;
  }

  :disabled {
    p,
    svg {
      color: rgba(0, 0, 0, 0.26);
    }
  }
`;

export const Section = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-direction: column;
`;

export const SectionCard = styled(Button)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 15px;
  gap: 10px;
  width: 100%;
  height: 60px;
  border: 1px solid #bdbdbd;
  border-radius: 6px;
  margin-top: 10px;
  text-transform: none;

  :hover {
    background-color: #e9e9e9;
    cursor: pointer;
  }
`;

export const SectionInfo = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SectionText = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;
  color: #424242;
`;

export const EmptySection = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 80px 0;
`;

export const MoveButton = styled(Button)`
  color: #fff;
  font-weight: 500;
  font-size: 15px;
  margin-top: 20px;
  width: 100%;
`;
